import React from 'react';
import { TemplateType } from '../TemplateType';
import usePdfContent, { PdfContentParams } from '../usePdfContent';

import PdfContent from 'apps/Pdf/components/common/PdfContent';
import Title from 'apps/Pdf/components/common/Title';
import BasicData from 'apps/Pdf/components/BasicData/BasicData';
import P from 'apps/Pdf/components/common/P';
import Loading from 'apps/Pdf/components/common/Loading';
import useColorStyles from 'apps/Pdf/styles/colors';
import { RequestContent, RequestTypes } from './RequestInterface';
import { PdfCategory } from '../Interfaces';

const Request = (params: PdfContentParams) => {
  const pdfContent = usePdfContent<RequestContent>({
    category: PdfCategory.REQUEST,
    templateType: TPL_GENERIC_REQUEST,
    ...params,
  });

  const data = pdfContent?.data ? pdfContent.data : ({} as RequestContent);
  const colors = useColorStyles({ code: pdfContent?.data?.header.signedVia || '' });

  return pdfContent ? (
    <PdfContent errors={pdfContent?.errors} className={colors.root} onload afterLoad={params.afterLoad}>
      <Title>
        {data.type === RequestTypes.TWOFACTOR_DISABLE && 'Vypnutí dvoufaktorového přihlašování'}
        {data.type === RequestTypes.TWOFACTOR_ENABLE && 'Zapnutí dvoufaktorového přihlašování'}
      </Title>

      <BasicData data={data.header} />

      {data.type === RequestTypes.TWOFACTOR_DISABLE && (
        <>
          <P>
            Souhlasím s jednofaktorovým přihlašováním k účtu: jedná se o zjednodušené přihlašování k účtu pouze pomocí
            uživatelského jména a hesla. Jsem si vědom, že tento způsob je méně bezpečný než dvoufaktorové přihlašování
            pomocí hesla a jednorázového kódu.
          </P>
          <P>Žádám tímto vypnutí druhého faktoru zabezpečení při přihlašování.</P>
        </>
      )}
      {data.type === RequestTypes.TWOFACTOR_ENABLE && (
        <>
          <P>
            Souhlasím s dvoufaktorovým přihlašováním k účtu: dvoufaktorové ověření představuje vyšší míru zabezpečení
            osobních dat uložených v aplikaci Edward. Klient si při prvním přihlášení nastaví kromě hesla, také
            jednorázový kód pomocí mobilní aplikace.
          </P>
          <P>Žádám tímto zapnutí druhého faktoru zabezpečení při přihlašování.</P>
        </>
      )}
    </PdfContent>
  ) : params.preview ? (
    <Loading />
  ) : null;
};

const TPL_GENERIC_REQUEST: TemplateType = 'request';

export { TPL_GENERIC_REQUEST, Request };
